module.exports = __webpack_public_path__ + "static/media/MobileSellerboxFunction05.4bdcf087.png";